import ArticleName from "shared/Types/articles";

import {ArticleData as Article_1} from "./Article_1/ArticleData";
import {ArticleData as Article_10} from "./Article_10/ArticleData";
import {ArticleData as Article_11} from "./Article_11/ArticleData";
import {ArticleData as Article_12} from "./Article_12/ArticleData";
import {ArticleData as Article_13} from "./Article_13/ArticleData";
import {ArticleData as Article_14} from "./Article_14/ArticleData";
import {ArticleData as Article_15} from "./Article_15/ArticleData";
import {ArticleData as Article_16} from "./Article_16/ArticleData";
import {ArticleData as Article_17} from "./Article_17/ArticleData";
import {ArticleData as Article_18} from "./Article_18/ArticleData";
import {ArticleData as Article_2} from "./Article_2/ArticleData";
import {ArticleData as Article_3} from "./Article_3/ArticleData";
import {ArticleData as Article_4} from "./Article_4/ArticleData";
import {ArticleData as Article_5} from "./Article_5/ArticleData";
import {ArticleData as Article_6} from "./Article_6/ArticleData";
import {ArticleData as Article_7} from "./Article_7/ArticleData";
import {ArticleData as Article_8} from "./Article_8/ArticleData";
import {ArticleData as Article_9} from "./Article_9/ArticleData";

export const useArticlesData = (name) => {
  const data = {
    [ArticleName.ARTICLE_1]:  Article_1(),
    [ArticleName.ARTICLE_2]:  Article_2(),
    [ArticleName.ARTICLE_3]:  Article_3(),
    [ArticleName.ARTICLE_4]:  Article_4(),
    [ArticleName.ARTICLE_5]:  Article_5(),
    [ArticleName.ARTICLE_6]:  Article_6(),
    [ArticleName.ARTICLE_7]:  Article_7(),
    [ArticleName.ARTICLE_8]:  Article_8(),
    [ArticleName.ARTICLE_9]:  Article_9(),
    [ArticleName.ARTICLE_10]: Article_10(),
    [ArticleName.ARTICLE_14]: Article_14(),
    [ArticleName.ARTICLE_15]: Article_15(),
    [ArticleName.ARTICLE_13]: Article_13(),
    [ArticleName.ARTICLE_16]: Article_16(),
    [ArticleName.ARTICLE_17]: Article_17(),
    [ArticleName.ARTICLE_18]: Article_18(),
    [ArticleName.ARTICLE_11]: Article_11(),
    [ArticleName.ARTICLE_12]: Article_12(),
  };

  if (!name) {
    return data;
  }
  return data[name];
};
